export const selectContraList = (state) => state.contra.contraList;
export const selectContraAccounts = (state) => state.contra.accounts;
export const selectContraTagGroups = (state) => state.contra.tagGroups;
export const selectContraCode = (state) => state.contra.contraCode;
export const selectContraLoading = (state) => state.contra.loading;
export const selectContraError = (state) => state.contra.error;
